
import { defineComponent, nextTick, reactive, ref, computed } from 'vue'
import PageContent from '@/components/page-content'
import ClassStatisticsDialog from './components/ClassStatisticsDialog.vue'

import { contentTableConfig } from './config/content.config'
import formatUtcString from '@/utils/date-format'
import { ElMessage, ElMessageBox } from 'element-plus'
import {
  getGeoArea, editTeacher, getTeacherFreeTime, blackTeacher,deleteTeacher
} from '@/service/main/system/system'

export default defineComponent({
  name: 'teacher',
  components: {
    PageContent,
    ClassStatisticsDialog
  },
  setup() {
    const dialogVisible = ref(false)
    const data = ref([])
    const pageContentRef = ref()
    const modalshow = ref(false)
    const teacherInfoVisible = ref(false)
    const classStatisticsShow = ref(false)
    const form = reactive({
      radioValue: '1',
      reson: ''
    })
    let use_id = ref('') // 用户id

    // 教师详情数据
    const teacherDetail = reactive({
      userId: '',
      nickName: '',
      avatar: '',
      phonenumber: '',
      idCard: '',
      educationImage: '',
      educationList: [] as any[],
      subjectList: [] as any[],
      teachingAge: '',
      address: '',
      remark: '',
      backgroundImage: '',
      breakPromiseTimes: 0
    })
    const geoAreaList = ref<any[]>([])
    const areaValue = ref('')
    const areaInfo = ref<any>({
      province: '',
      city: '',
      county: '',
      userFlag: 'T'
    })
    // 按日期分组时间数据
    const groupedTimeData = computed(() => {
      const grouped: Record<string, string[]> = {}

      data.value.forEach((timeStr: string) => {
        const datePart = timeStr.split(' ')[0]
        if (!grouped[datePart]) {
          grouped[datePart] = []
        }
        const timePart = timeStr.split(datePart)[1].trim()
        grouped[datePart].push(timePart)
      })

      return grouped
    })
    const getGeoAreaList = async () => {
      const res: any = await getGeoArea('/app/area/getAreaTree', {
        type: 0
      })
      geoAreaList.value = res?.data
      if (geoAreaList.value.length > 0 && geoAreaList.value[0].child.length > 0) {
        // 默认选择第一个城市
        areaValue.value = geoAreaList.value[0].child[0].id
        areaInfo.value.province = geoAreaList.value[0].name
        areaInfo.value.city = geoAreaList.value[0].child[0].name
        areaInfo.value.county = geoAreaList.value[0].child[0].child[0].name
      }
    }

    const handleAreaChange = (value: string) => {
      // 找到对应的省市信息
      for (const province of geoAreaList.value) {
        for (const city of province.child) {
          if (city.id === value) {
            areaInfo.value.province = province.name
            areaInfo.value.city = city.name
          }
        }
      }
    }

    getGeoAreaList()

    const editTeacherStaus = (userId: any) => {
      modalshow.value = true
      use_id.value = userId
    }

    const getTeacherStatistics = (userId: string) => {
      classStatisticsShow.value = true
      use_id.value = userId
    }

    const getTeacherInfo = (row: any) => {
      console.log(row)
      // 手动为每个属性赋值，避免类型问题
      if (row.userId) teacherDetail.userId = row.userId
      if (row.nickName) teacherDetail.nickName = row.nickName
      if (row.avatar) teacherDetail.avatar = row.avatar
      if (row.phonenumber) teacherDetail.phonenumber = row.phonenumber
      if (row.idCard) teacherDetail.idCard = row.idCard
      if (row.educationImage) teacherDetail.educationImage = row.educationImage
      if (row.educationList) teacherDetail.educationList = row.educationList || []
      if (row.subjectList) teacherDetail.subjectList = row.subjectList || []
      if (row.teachingAge) teacherDetail.teachingAge = row.teachingAge
      if (row.address) teacherDetail.address = row.address
      if (row.remark) teacherDetail.remark = row.remark
      if (row.backgroundImage) teacherDetail.backgroundImage = row.backgroundImage
      if (row.breakPromiseTimes) teacherDetail.breakPromiseTimes = row.breakPromiseTimes

      teacherInfoVisible.value = true
    }

    const getTeacherTime = (userId: any) => {
      getTeacherFreeTime('/pc/userInfo/getFreeTime', {
        userId
      }).then(res => {
        console.log(res)
        data.value = res.data
        dialogVisible.value = true
      })
    }

      const changeTeacherBlackStatus = (userId: any, isBlack: any, nickName: any) => {
      ElMessageBox.confirm(isBlack == 'Y' ? `确定要拉黑${nickName}吗？` : `确定要解除拉黑${nickName}吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
      blackTeacher('/pc/teacherInfo/edit', {
        userId,
        isBlack
      }).then(res => {
        console.log(res)
        ElMessage.success('操作成功')
        pageContentRef.value.getPageData()
      })
    })
    }
    const delTeacher = (userId: any, nickName: any) => {
      ElMessageBox.confirm(`确定要删除${nickName}吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
      deleteTeacher(`/pc/teacherInfo/${userId}`).then(res => {
        console.log(res)
        ElMessage.success('删除成功!')
        pageContentRef.value.getPageData()
      })
    })
    }
    const handleSubmit = () => {
      editTeacher('/pc/teacherInfo/edit', {
        userId: use_id.value,
        approveStatus: form.radioValue,
        reviewContent: form.radioValue
      }).then(res => {
        modalshow.value = false
        pageContentRef.value.getPageData()
      })
    }

    return {
      form,
      use_id,
      modalshow,
      teacherInfoVisible,
      classStatisticsShow,
      teacherDetail,
      contentTableConfig,
      editTeacherStaus,
      getTeacherInfo,
      getTeacherTime,
      pageContentRef,
      dialogVisible,
      handleSubmit,
      data,
      groupedTimeData,
      formatUtcString,
      handleAreaChange,
      areaValue,
      geoAreaList,
      areaInfo,
      changeTeacherBlackStatus,
      delTeacher,
      getTeacherStatistics
    }
  }
})
